export const style = {
  mainBox: {
    sx: {
      mb: 4,
    },
  },
  box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  button: {
    variant: 'text',
    style: { backgroundColor: 'transparent' },
    sx: {
      alignItems: 'center',
      display: 'flex',
      color: 'text.secondary',
      pr: 1,
    },
  },
  icon: {
    fontSize: 'small',
    sx: {
      mr: 1,
    },
  },
  typography: {
    variant: 'subtitle2',
  },
  divider: {
    sx: {
      color: 'text.secondary',
    },
  },
  current: {
    sx: {
      pl: 1,
    },
  },
} as const;

export default style;
